import React, { useState, useMemo, memo } from 'react';
import { Chip, Button, Card, CardBody } from "@nextui-org/react";

const ProjectComponent = memo(({ images, title, year, desc }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const imagesArray = Array.isArray(images) ? images : [images];

    const nextImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % imagesArray.length);
    };

    const prevImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + imagesArray.length) % imagesArray.length);
    };

    // Ağır hesaplamalar için useMemo kullanın
    const processedImages = useMemo(() => {
        return imagesArray.map(image => ({ 
            src: image,
            thumbnail: image // createThumbnail yerine doğrudan orijinal resmi kullan
        }));
    }, [imagesArray]);

    return (
        <>
            <Card className="w-full mb-32 bg-background/60 dark:bg-default-100/50 backdrop-blur-sm">
                <CardBody className="p-4 md:p-8">
                    {/* Başlık Bölümü */}
                    <div className="text-center mb-8">
                        <h2 className="font-bold text-4xl md:text-5xl mb-4 ">
                            {title}
                        </h2>
                        <Chip 
                            className="text-lg" 
                            color="success" 
                            variant="shadow"
                        >
                            {year}
                        </Chip>
                    </div>

                    <div className="flex flex-col lg:flex-row gap-8">
                        {/* Ana Görsel Bölümü */}
                        <div className="w-full lg:w-2/3">
                            <div 
                                className="relative rounded-2xl overflow-hidden shadow-xl group bg-black"
                            >
                                <img 
                                    src={processedImages[currentIndex].src} 
                                    className="w-full h-[400px] md:h-[500px] lg:h-[600px] object-contain transform transition-all duration-500 group-hover:scale-105" 
                                    alt={`${title} projesi - ${currentIndex + 1}. görsel`} 
                                    loading="lazy"
                                />


                                {/* Navigasyon Butonları */}
                                <div className="absolute inset-y-0 left-0 right-0 flex items-center justify-between p-4 opacity-0 group-hover:opacity-100 transition-opacity">
                                    <Button
                                        isIconOnly
                                        className="bg-black/50 backdrop-blur-sm hover:bg-black/70"
                                        variant="flat"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            prevImage();
                                        }}
                                    >
                                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"/>
                                        </svg>
                                    </Button>
                                    <Button
                                        isIconOnly
                                        className="bg-black/50 backdrop-blur-sm hover:bg-black/70"
                                        variant="flat"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            nextImage();
                                        }}
                                    >
                                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"/>
                                        </svg>
                                    </Button>
                                </div>

                                {/* Görsel Sayacı */}
                                <div className="absolute bottom-4 right-4 bg-black/50 backdrop-blur-sm px-4 py-2 rounded-full text-white">
                                    <span className="font-medium">{currentIndex + 1} / {imagesArray.length}</span>
                                </div>
                            </div>

                            {/* Küçük Resimler */}
                            <div className="flex gap-3 mt-4 overflow-x-auto pb-2 px-1">
                                {processedImages.map((img, idx) => (
                                    <button
                                        key={idx}
                                        onClick={() => setCurrentIndex(idx)}
                                        className={`relative flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden transition-all ${
                                            currentIndex === idx 
                                                ? 'ring-2 ring-primary scale-105' 
                                                : 'opacity-70 hover:opacity-100 hover:scale-105'
                                        }`}
                                    >
                                        <img 
                                            src={img.thumbnail} 
                                            alt={`${title} projesi küçük görsel ${idx + 1}`}
                                            className="w-full h-full object-cover"
                                            loading="lazy"
                                        />
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Açıklama Bölümü */}
                        <div className="w-full lg:w-1/3 flex flex-col justify-center">
                            <Card className="bg-gradient-to-br from-primary-50/50 to-danger-50/50 dark:from-primary-900/20 dark:to-danger-900/20 backdrop-blur-sm">
                                <CardBody className="p-6 lg:p-8">
                                    <div className="prose prose-lg dark:prose-invert">
                                        <p className="text-lg leading-relaxed">
                                            {desc}
                                        </p>
                                    </div>
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </>
    );
});

export default ProjectComponent;
                